import { IShoppingCartState } from '@/@types'

const state: IShoppingCartState = {
  shoppingCart: [],
  selectedPlan: {},
  bundleProductHasError: false,
  addOnsCertificationsList: [],
  selectedAddOnsByUser: false,
  savedAt: null,
}

export default state
